import { render, staticRenderFns } from "./testsDetail.vue?vue&type=template&id=56401746&scoped=true"
import script from "./testsDetail.vue?vue&type=script&lang=js"
export * from "./testsDetail.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/lib/testsDetail.scss?vue&type=style&index=0&id=56401746&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56401746",
  null
  
)

export default component.exports